module.exports = __webpack_public_path__ + "f8b9607ea16b8e61e68903bf3a557383.svg";